/* eslint-disable jira/filename-case */
import type { GadgetUserPreferences } from '@jira/global-pages__dashboard-user-preference/src/types.tsx';

export const isGadgetConfigured = (userPrefs: GadgetUserPreferences | undefined): boolean =>
	userPrefs?.fields.some(({ name, value }) => name === 'isConfigured' && value === 'true') ?? false;
